import { LoginPage } from '.';

const routes = {
    path: '/',
    name: 'Home',
    childRoutes: [
        {
            path: 'start',
            name: 'Login page',
            component: LoginPage,
            isIndex: true,
            isPublic: true,
            childRoutes: [],
        },
    ],
};
export default routes;
